import TkInfoManual from "../../components/atoms/TkInfoManual";
import "./_style.scss";
import { useContext, useEffect, useMemo, useState } from "react";
import TkTitle from "../../components/atoms/TkTitle";
import { Box } from "@mui/material";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import TkFileUpload from "../../components/molecules/TkFileUpload";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkButton from "../../components/atoms/TkButton";
import { useLocation, useNavigate } from "react-router-dom";
import { httpAPI_RET004 } from "./api/request";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { FormClassRetire, FormKbn } from "../../assets/data/Constants";
import { IJob_35Props } from "../../type/contextType/businessContext/IJob_35";
import { IJob_41Props } from "../../type/contextType/businessContext/IJob_41";
import { IAPI_RET004_Response } from "../../type/apiType";

/**
 * SCRR410003 退職手当金の請求手続き前の書類の準備
 * @Todo 持ち回り情報
 * @return SCRR410003 退職手当金の請求手続き前の書類の準備
 */
const SCRR410003 = () => {
  const navigate = useNavigate();
  const loaction = useLocation();

  //グローバルContextを更新するState
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state: globalState } = useContext(GlobalContext);
  const [checkValue1, setCheckValue1] = useState<boolean>(false);
  const [checkValue2, setCheckValue2] = useState<boolean>(false);
  const [checkValue3, setCheckValue3] = useState<boolean>(false);
  const [uploadFile, setUpLoadFile] = useState<any>([]);
  const [fileUploadError, setFileUploadError] = useState<boolean>(false);
  const [defaultFile, setDefaultFile] = useState<any>([]);
  const userType = globalState.authInfo?.userType;
  const isHojinUser = userType === authorityUserType.userTypeNumber.KEIYAKUSYA;
  const isRetiree = userType === authorityUserType.userTypeNumber.TAISYOKUSYA;
  const isKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const location = useLocation();
  const businessType =
    location?.state?.businessType ?? businessState.common?.businessType;
  const jobName = businessType
    ?.toLowerCase?.()
    .replace?.("-", "_") as keyof typeof businessState;
  const applyId =
    location?.state?.applyId ??
    businessState.job_35?.applyId ??
    businessState.job_41?.applyId;
  const [resData, setResData] = useState<IAPI_RET004_Response>({});

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isNextDisabled = useMemo(() => {
    return !(
      checkValue1 &&
      checkValue2 &&
      checkValue3 &&
      (isHojinUser ? uploadFile && uploadFile.length > 0 : true) &&
      !fileUploadError
    );
  }, [
    checkValue1,
    checkValue2,
    checkValue3,
    uploadFile,
    fileUploadError,
    isHojinUser,
  ]);

  const handleEditFileList = ():
    | IJob_35Props["fileList"]
    | IJob_41Props["fileList"] => {
    const sourceList =
      (businessState[jobName] as IJob_35Props | IJob_41Props)?.fileList ?? [];

    const newFile = {
      facilityNo: "",
      formKbn: FormKbn["退職書類"],
      formClass: FormClassRetire["委任状"],
      formName: uploadFile[0]?.formName,
      file: uploadFile[0]?.fileBase64,
      issueDocumentNo: "",
      issueDate: "",
    };
    const existingFileIndex = sourceList.findIndex(
      (file: any) =>
        file.formKbn === FormKbn["退職書類"] &&
        file.formClass === FormClassRetire["委任状"]
    );

    const nextFileList = [...sourceList];
    if (existingFileIndex >= 0) {
      nextFileList.splice(existingFileIndex, 1, newFile);
    } else {
      nextFileList.push(newFile);
    }

    return nextFileList.map((item, index) => ({
      ...item,
      serialNo: index + 1,
    }));
  };

  const clickNext = () => {
    if (isHojinUser && businessType !== "JOB-41") {
      setBusinessState({
        ...businessState,
        job_35: {
          ...businessState.job_35,
          fileList: handleEditFileList(),
          sendMoneyAbroad:
            isKiko && resData.domesticResidenceFlg && !resData.depositType
              ? "1"
              : "0",
        },
      });

      navigate("/SCRR410004");
    } else {
      if (businessState.common?.businessType === "JOB-35") {
        setBusinessState({
          ...businessState,
          job_35: {
            ...businessState.job_35,
            sendMoneyAbroad:
              isKiko && resData.domesticResidenceFlg && !resData.depositType
                ? "1"
                : "0",
          },
        });
        navigate("/SCRR410004");
      } else {
        if (businessType === "JOB-41") {
          setBusinessState({
            ...businessState,
            job_41: {
              ...businessState.job_41,
              fileList: handleEditFileList(),
            },
          });
        }

        navigate("/SCRR411123", {
          state: {
            staffNo: loaction.state?.staffNo,
          },
        });
      }
    }
  };

  const handleInit = async () => {
    try {
      const res = await httpAPI_RET004({
        applyId,
        contractorNo:
          isHojinUser || isRetiree
            ? globalState.authInfo?.contractorNo
            : businessState.common?.contractorNo,
        staffNo: loaction.state?.staffNo
          ? loaction.state?.staffNo
          : businessState.common?.businessType === "JOB-35"
          ? businessState.job_35?.staffNo ?? ""
          : businessState.job_41?.staffNo ?? "",
      });
      if (res.resultCd === "I0000") {
        setResData(res);
        setBusinessState({
          common: {
            ...businessState.common,
            businessType,
            contractorNo: isRetiree
              ? globalState.authInfo?.contractorNo
              : res.contractorNo,
          },
          [jobName]: {
            businessType,
            staffNo: isRetiree ? globalState.authInfo?.staffNo : res.staffNo,
            staffName: res.retirementStaffName,
            applyId: res.applyId,
            tempSaveStep: res.tempSaveStep,
            demanderName: res.demanderName,
            demanderNameKana: res.demanderNameKana,
            demanderKbn: res.demanderKbn,
            demanderRelationship: res.demanderRelationship,
            demanderRelationshipOthers: res.demanderRelationshipOthers,
            demanderBirth: res.demanderBirth,
            birthday: res.birthday,
            tel: res.tel,
            demanderEmail: res.demanderEmail,
            agentEmail: res.agentEmail,
            demanderZipcode: res.demanderZipcode,
            demanderPrefectureCd: res.demanderPrefectureCd,
            demanderCity: res.demanderCity,
            demanderAddressOthers: res.demanderAddressOthers,
            retirementReason: res.retirementReason,
            retirementYearFirstZipcode: res.retirementYearFirstZipcode,
            retirementYearFirstPrefectureCd:
              res.retirementYearFirstPrefectureCd,
            retirementYearFirstAddressCity: res.retirementYearFirstAddressCity,
            retirementYearAddressOthers: res.retirementYearAddressOthers,
            demanderFlg: res.demanderFlg,
            livelihoodFromRetireeFlg: res.livelihoodFromRetireeFlg,
            domesticResidenceFlg: isKiko ? res.domesticResidenceFlg : undefined,
            bankCd: res.bankCd,
            bankName: res.bankName,
            branchCd: res.branchCd,
            branchName: res.branchName,
            accountNameKana: res.accountNameKana,
            depositType: res.depositType,
            accountNo: res.accountNo,
            prefectureRetirementJoinFlg: res.prefectureRetirementJoinFlg,
            retirementRequestOrder: res.retirementRequestOrder,
            addPaymentApplyFlg: res.addPaymentApplyFlg,
            addPaymentReason: res.addPaymentReason,
            addPaymentAmt: res.addPaymentAmt,
            totalPaymentAmtAfterAdd: res.totalPaymentAmtAfterAdd,
            totalYearLosFrom: res.pastLosInCurrentYearTotalFrom,
            totalYearLosTo: res.pastLosInCurrentYearTotalTo,
            totalCurrentYearLosFrom: res.pastLosInCurrentYearOtherFrom,
            totalCurrentYearLosTo: res.pastLosInCurrentYearOtherTo,
            duplicationLosYear: res.duplicationLosYear,
            duplicationLosFrom: res.duplicationLosFrom,
            duplicationLosTo: res.duplicationLosTo,
            retirementFormApplyId: res.retirementFormApplyId,
            page1Kbn: res.page1Kbn,
            page1PaymentAmt: res.page1PaymentAmt,
            page1WithholdingAmt: res.page1WithholdingAmt,
            page1ScAmtCity: res.page1ScAmtCity,
            page1ScAmtPrefecture: res.page1ScAmtPrefecture,
            page1LengthOfService: res.page1LengthOfService,
            page1EmployedDate: res.page1EmployedDate,
            page1RetiredDate: res.page1RetiredDate,
            page1DeductionPeriodYear: res.page1DeductionPeriodYear,
            page1DeductionPeriodMonth: res.page1DeductionPeriodMonth,
            page1WamDelFlg: res.page1WamDelFlg,
            page2Kbn: res.page2Kbn,
            page2PaymentAmt: res.page2PaymentAmt,
            page2WithholdingAmt: res.page2WithholdingAmt,
            page2ScAmtCity: res.page2ScAmtCity,
            page2ScAmtPrefecture: res.page2ScAmtPrefecture,
            page2LengthOfService: res.page2LengthOfService,
            page2EmployedDate: res.page2EmployedDate,
            page2RetiredDate: res.page2RetiredDate,
            page2DeductionPeriodYear: res.page2DeductionPeriodYear,
            page2DeductionPeriodMonth: res.page2DeductionPeriodMonth,
            page2WamDelFlg: res.page2WamDelFlg,
            page3Kbn: res.page3Kbn,
            page3PaymentAmt: res.page3PaymentAmt,
            page3WithholdingAmt: res.page3WithholdingAmt,
            page3ScAmtCity: res.page3ScAmtCity,
            page3ScAmtPrefecture: res.page3ScAmtPrefecture,
            page3LengthOfService: res.page3LengthOfService,
            page3EmployedDate: res.page3EmployedDate,
            page3RetiredDate: res.page3RetiredDate,
            page3DeductionPeriodYear: res.page3DeductionPeriodYear,
            page3DeductionPeriodMonth: res.page3DeductionPeriodMonth,
            page3WamDelFlg: res.page3WamDelFlg,
            deductionPeriodYear: res.deductionPeriodYear,
            deductionPeriodMonth: res.deductionPeriodMonth,
            identificationDocsKind: res.identificationDocsKind,
            retireKbn: res.retireKbn,
            firstJoinDate: res.firstJoinDate,
            retireDate: res.retireDate,
            livingAssistanceFlg: res.livingAssistanceFlg,
            paymentConfirmDate: res.paymentConfirmDate,
            currentYearLosFrom: res.currentYearLosFrom,
            currentYearLosTo: res.currentYearLosTo,
            currentYearPaymentDecisionDate: res.currentYearPaymentDecisionDate,
            currentYearRetirementAllowanceAmt:
              res.currentYearRetirementAllowanceAmt,
            currentYearWithholdingAmt: res.currentYearWithholdingAmt,
            currentYearScCityAmt: res.currentYearScCityAmt,
            currentYearScPrefectureAmt: res.currentYearScPrefectureAmt,
            currentYearGetPaidDate: res.currentYearGetPaidDate,
            currentYearRetirementKbn: res.currentYearRetirementKbn,
            currentYearPayerZipcode: res.currentYearPayerZipcode,
            currentYearPayerPrefectureCd: res.currentYearPayerPrefectureCd,
            currentYearPayerAddressCity: res.currentYearPayerAddressCity,
            currentYearPayerAddressOthers: res.currentYearPayerAddressOthers,
            currentYearPayerName: res.currentYearPayerName,
            past4yearsLosFrom: res.past4yearsLosFrom,
            past4yearsLosTo: res.past4yearsLosTo,
            past4yearsPaymentDecisionDate: res.past4yearsPaymentDecisionDate,
            past4yearsRetirementAllowanceAmt:
              res.past4yearsRetirementAllowanceAmt,
            past4yearsWithholdingAmt: res.past4yearsWithholdingAmt,
            past4yearsScCityAmt: res.past4yearsScCityAmt,
            past4yearsScPrefectureAmt: res.past4yearsScPrefectureAmt,
            past4yearsGetPaidDate: res.past4yearsGetPaidDate,
            past4yearsRetirementKbn: res.past4yearsRetirementKbn,
            past4yearsPayerZipcode: res.past4yearsPayerZipcode,
            past4yearsPayerPrefectureCd: res.past4yearsPayerPrefectureCd,
            past4yearsPayerAddressCity: res.past4yearsPayerAddressCity,
            past4yearsPayerAddressOthers: res.past4yearsPayerAddressOthers,
            past4yearsPayerName: res.past4yearsPayerName,
            missingFileList: res.missingFileList,
            staffNameKana: res.staffNameKana,
            staffNameKanji: res.staffNameKanji,
            memoList: res.memoList,
            reserveFlg: res.reserveFlg,
            reserveReasonCd: res.reserveReasonCd,
            limitationFlg: res.limitationFlg,
            limitationDate: res.limitationDate,
            approvalDate: res.approvalDate,
            symbolNo: res.symbolNo,
            retirementProcedureReason: res.retirementProcedureReason,
            finalRetirementReason: res.finalRetirementReason,
            maePeriodYear: res.maePeriodYear,
            maePeriodMonth: res.maePeriodMonth,
            contractorName: res.contractorName,
            fileList: res.fileList,
            retirementStaffName: res.retirementStaffName,
            facilityNo: res.finalFacilityNo,
            facilityName: res.facilityName,
            retirementZipcode: res.retirementZipcode,
            retirementPrefectureCd: res.retirementPrefectureCd,
            retirementAddressCity: res.retirementAddressCity,
            retirementAddressOthers: res.retirementAddressOthers,
            retirementTel: res.retirementTel,
          } as IJob_35Props | IJob_41Props,
        });

        setCheckValue1(!!res.applyId);
        setCheckValue2(!!res.applyId);
        setCheckValue3(!!res.applyId);

        if (isHojinUser) {
          if (res.fileList) {
            const filteredFileList = res.fileList.find(
              (file) =>
                file.formKbn === FormKbn["退職書類"] &&
                file.formClass === FormClassRetire["委任状"]
            );

            if (filteredFileList) {
              setDefaultFile([
                {
                  formName: filteredFileList.formName,
                  fileBase64: filteredFileList.file,
                },
              ]);
            }
          }
        }
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRR410003PageForTest" className="tkSCRR410003">
      <TkInfoManual children={labelids.labelid.LBLR410003_01} rule={"\\n"} />
      <TkInfoManual children={labelids.labelid.LBLR410003_02} rule={"\\n"} />
      <TkInfoManual children={labelids.labelid.LBLR410003_03} rule={"\\n"} />
      <TkInfoManual children={labelids.labelid.LBLR410003_04} rule={"\\n"} />
      <TkInfoManual children={labelids.labelid.LBLR410003_05} rule={"\\n"} />
      <TkTitle>【確認事項】</TkTitle>
      <Box className="tkAtentionContents">
        <Box>
          <TkInfoManual
            children={labelids.labelid.LBLR410003_06}
            rule={"\\n"}
          />
          <Box className="tkInputContents">
            <TkCheckbox
              label="保存できている"
              checked={checkValue1}
              onChange={() => setCheckValue1(!checkValue1)}
            ></TkCheckbox>
          </Box>
        </Box>
        <Box>
          <TkInfoManual
            children={labelids.labelid.LBLR410003_07}
            rule={"\\n"}
          />
          <Box className="tkInputContents">
            <TkCheckbox
              label="保存できている"
              checked={checkValue2}
              onChange={() => setCheckValue2(!checkValue2)}
            ></TkCheckbox>
          </Box>
        </Box>
        <Box>
          <TkInfoManual
            children={labelids.labelid.LBLR410003_08}
            rule={"\\n"}
          />
          <Box className="tkInputContents">
            <TkCheckbox
              label="保存できている"
              checked={checkValue3}
              onChange={() => setCheckValue3(!checkValue3)}
            ></TkCheckbox>
          </Box>
        </Box>
        {isHojinUser && (
          <Box>
            <TkInfoManual
              children={labelids.labelid.LBLR410003_09}
              rule={"\\n"}
            />
            <Box className="tkInputContents">
              <TkFileUpload
                multiple={false}
                wantToSetValue={defaultFile}
                onChange={(e: any) => setUpLoadFile(e.target?.value)}
                onGetError={setFileUploadError}
              />
            </Box>
          </Box>
        )}
      </Box>
      <Box className="tkButton">
        <TkBackButton />
        <TkButton onClick={clickNext} disabled={isNextDisabled}>
          次へ
        </TkButton>
      </Box>
    </Box>
  );
};

export default SCRR410003;
